import { HomePage } from "./../home/home";
import { TranslateService } from "@ngx-translate/core";
import { Http, RequestOptions, Headers } from "@angular/http";
import { ServiceProvider } from "./../../providers/service/service";
import { Storage } from "@ionic/storage";
import { ViewHeaderPage } from "./../view-header/view-header";
import { Component } from "@angular/core";
import { IonicPage, NavController, LoadingController } from "ionic-angular";

@IonicPage()
@Component({
  selector: "page-plaza-cashflow",
  templateUrl: "plaza-cashflow.html",
})
export class PlazaCashflowPage {
  datas = [
    {
      round: 1,
      beginning_cash: {
        beginning_budget: "",
        investment_in_theme: "",
        investment_in_social: "",
        operating_expense_in_theme: "",
        operating_expense_in_social: "",
        revenue_from_rent: "",
        revenue_from_social_ticket: "",
        refund_from_social_investment: "",
      },
      ending_cash: "",
    },
  ];
  theme = 1;

  constructor(
    public navCtrl: NavController,
    private storage: Storage,
    private services: ServiceProvider,
    private http: Http,
    public translateService: TranslateService,
    private loadingCtrl: LoadingController
  ) {}

  async ionViewDidLoad() {
    this.theme = await this.storage.get("theme");

    const loader = this.loadingCtrl.create({
      content: "Loading...",
    });
    loader.present();

    this.storage.get("token").then((token) => {
      this.storage.get("roundGame").then((round) => {
        var link = this.services.URLPlazaStatCashflow;
        var headers = new Headers();
        headers.append("Accept", "application/json");
        headers.append("Authorization", "Bearer " + token);
        const requestOptions = new RequestOptions({ headers: headers });

        this.http
          .get(link, requestOptions)
          .map((res) => res.json())
          .subscribe(
            (data) => {
              this.datas = data;
              loader.dismiss();
            },
            (error) => {
              var response = JSON.parse(error._body);
              loader.dismiss();
              this.translateService.get(response.message).subscribe((value) => {
                this.services.presentToast(value);
              });
            }
          );
      });
    });
  }

  backPage() {
    this.navCtrl.pop();
  }

  homePage() {
    this.navCtrl.setRoot(HomePage);
  }

  openHeadPage() {
    this.navCtrl.push(ViewHeaderPage);
  }
}



// WEBPACK FOOTER //
// ./src/pages/plaza-cashflow/plaza-cashflow.ts